module.exports = __webpack_public_path__ + "img/onboard-wifi.745672e8.svg";